<template>
  <v-container class="px-0 my-3">
    <v-row>
      <v-col class="v-col-12 v-col-lg-3 d-none d-lg-block">
        <div class="w-100 bg-white">
          <v-list class="pa-0 br-top-5">
            <v-list-item prepend-icon="mdi-menu" class="bg-color-2 text-white">Serviços</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'folhetos' ? true : false" @click="$router.push('/services/folhetos')" class="link-menu cy-services-folhetos">
              <div class="d-flex align-center">
                <Svgs :icon="'folheto'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Folhetos</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'lembretes' ? true : false" @click="$router.push('/services/lembretes')" class="link-menu cy-services-lembretes">
              <div class="d-flex align-center">
                <Svgs :icon="'lembrete'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Lembretes</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'premios' ? true : false" @click="$router.push('/services/premios')" class="link-menu cy-services-premios">
              <div class="d-flex align-center">
                <Svgs :icon="'premios'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Prêmios e Brindes</span>
              </div>
            </v-list-item>
            <v-list-item v-if="checkModules(9) == 9" append-icon="mdi-chevron-right" :active="link == 'pontos' ? true : false" @click="$router.push('/services/pontos')" class="link-menu cy-services-pontos">
              <div class="d-flex align-center">
                <Svgs :icon="'foguete'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Programa de Pontos</span>
              </div>
            </v-list-item>
            <v-list-item v-if="checkModules(8) == 8" append-icon="mdi-chevron-right" :active="link == 'carteira' ? true : false" @click="$router.push('/services/carteira')" class="link-menu cy-services-carteira">
              <div class="d-flex align-center">
                <Svgs :icon="'carteira'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Carteira Digital</span>
              </div>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
      <v-col class="v-col-12 v-col-lg-9 px-6 px-lg-0" v-if="getConfig.isu == 0">
        <div class="w-100 bg-white pa-5 pb-10 br-top-5">
          <v-row class="mt-4">
            <v-col class="v-col-12 text-center">
              <span class="text-color-0 cursor-pointer" @click="openLogin()">Faça login ou crie seu cadastro para acessar essa página.</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col class="v-col-12 v-col-lg-9 px-6 px-lg-0" v-else>
        <div class="w-100 bg-white pa-5 pb-10 br-top-5" style="height: 100%">
          <v-breadcrumbs class="pa-0">
            <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0">Serviços</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
          </v-breadcrumbs>
          <h1 class="text-color-0 mt-2">{{ titulo }}</h1>
          <v-row class="mt-4" v-if="link == 'folhetos'">
            <v-col class="v-col-12" v-if="loadingFolhetos == true">
              <v-skeleton-loader type="image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
            </v-col>
            <v-col class="v-col-12" v-else-if="loadingFolhetos == false && getFolhetos.length > 0">
              <v-card v-for="f in getFolhetos" :key="f.hash" class="mb-3 border" variant="outlined" @click="visualizarFolheto(f)">
                <v-card-title class="text-color-1">
                  {{ f.title }}
                  <b class="float-right text-small text-color-2" v-if="checkView('folheto', f.id)">Novo!</b>
                </v-card-title>
                <v-card-text class="text-color-0 text-medium">Ofertas válidas até o dia {{ $formatDate(f.finish_date+" 00:00:00") }}</v-card-text>
              </v-card>
              <DialogFolheto :model="modelFolheto" :fechar="fechar" :folheto="selectedFolheto"></DialogFolheto>
            </v-col>
            <v-col class="v-col-12 text-center" v-else>
              <Svgs :icon="'folheto'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
              <br><br>
              <b class="text-color-0">NÃO HÁ FOLHETOS NO MOMENTO</b>
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="link == 'lembretes'">
            <v-col class="v-col-12" v-if="loadingLembretes == true">
              <v-skeleton-loader type="image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
            </v-col>
            <v-col class="v-col-12" v-else-if="loadingLembretes == false && getLembretes.length > 0">
              <v-card v-for="l in getLembretes" :key="l.id" class="mb-2 border" variant="outlined" @click="visualizarLembrete(l)">
                <v-card-title class="text-color-1">
                  {{ l.title }}
                  <b class="float-right text-small text-color-2" v-if="checkView('lembrete', l.id)">Novo!</b>
                </v-card-title>
                <v-card-subtitle class="text-color-0 mb-2">{{ $formatDate(l.date_hour) }} às {{ $formatTime(l.date_hour).replace(":", "h") }}</v-card-subtitle>
              </v-card>
              <DialogLembrete :model="modelLembrete" :fechar="fechar" :lembrete="selectedLembrete"></DialogLembrete>
            </v-col>
            <v-col class="v-col-12 text-center" v-else>
              <Svgs :icon="'lembrete'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
              <br><br>
              <b class="text-color-0">NÃO HÁ LEMBRETES NO MOMENTO</b>
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="link == 'premios'">
            <v-col class="v-col-12 text-center">
              <!-- <v-btn flat size="large" variant="outlined" class="bg-color-2 text-white" @click="tryShake()">Shake</v-btn> -->
              <DialogPremio :model="modelPremio" :fechar="fechar" :voucher="voucher"></DialogPremio>
            </v-col>
            <v-col class="v-col-12" v-if="loadingPremios == true">
              <v-skeleton-loader type="image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
            </v-col>
            <v-col class="v-col-12" v-else-if="loadingPremios == false && getPremios.length > 0">
              <v-card v-for="p in getPremios" :key="p.id" class="mb-2 border-color-0" variant="outlined" @click="visualizarPremio(p)">
                <v-card-title class="text-color-1">
                  {{ p.name }}
                  <b class="float-right text-small text-color-2" v-if="p.was_withdrawn == 1">Resgatado!</b>
                  <b class="float-right text-small text-color-0" v-else-if="comparaData(p.expiration)">Expirado!</b>
                </v-card-title>
                <v-card-text class="text-color-0">Data de Expiração: <b>{{ $formatDate(p.expiration) }} {{ $formatTime(p.expiration).replace(":", "h") }}</b></v-card-text>
              </v-card>
            </v-col>
            <v-col class="v-col-12 text-center" v-else>
              <Svgs :icon="'premios'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
              <br><br>
              <b class="text-color-0">NÃO HÁ PRÊMIOS NO MOMENTO</b>
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="link == 'pontos' && checkModules(9) == 9">
            <v-col class="v-col-12 text-center">
              <v-row>
                <v-col class="v-col-12 v-col-lg-3 d-flex align-center justify-center text-color-0">
                  <div v-if="navPontos == 'validade'" class="pontos pontos-border-vencer">
                    <span>
                      <v-skeleton-loader :loading="loadingPoints" type="text" class="justify-center">
                        <b class="text-xxlarge">{{ getPointsExpired ? getPointsExpired : 0 }}</b><br>
                      </v-skeleton-loader>
                      <span class="text-small">PONTOS A VENCER</span>
                    </span>
                  </div>
                  <div v-else class="pontos pontos-border-acumulado">
                    <span>
                      <v-skeleton-loader :loading="loadingPoints" type="text" class="justify-center">
                        <b class="text-xxlarge">{{ getPoints ? getPoints : 0 }}</b><br>
                      </v-skeleton-loader>
                      <span class="text-small">PONTOS ACUMULADOS</span>
                    </span>
                  </div>
                </v-col>
                <v-col class="v-col-12 v-col-lg-9 p-3 d-flex align-center justify-center flex-wrap">
                  <v-btn block flat size="large" variant="outlined" :class="navPontos == 'troca' ? 'bg-color-2 text-white': 'border-color-1 text-color-1'" @click="navPontos = 'troca'" class="text-medium">Trocar Pontos</v-btn>
                  <v-btn block flat size="large" variant="outlined" :class="navPontos == 'transacao' ? 'bg-color-2 text-white': 'border-color-1 text-color-1'" @click="navPontos = 'transacao'" class="text-medium mt-1">Histórico de Transações</v-btn>
                  <v-btn block flat size="large" variant="outlined" :class="navPontos == 'validade' ? 'bg-color-2 text-white': 'border-color-1 text-color-1'" @click="navPontos = 'validade'" class="text-medium mt-1">Validade</v-btn>
                  <v-btn block flat size="large" variant="outlined" :class="navPontos == 'ajuda' ? 'bg-color-2 text-white': 'border-color-1 text-color-1'" @click="navPontos = 'ajuda'" class="text-medium mt-1">Ajuda</v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-flex justify-content-between">
                <v-col v-if="navPontos == 'troca'" class="p-3" cols="12">
                  <v-skeleton-loader :loading="loadingHistory" type="image" width="100%" height="70px" class="with-margin justify-center">
                    <v-list class="lista-troca mt-9 w-100" v-if="getPointsProducts.length > 0">
                      <v-list-item v-for="(item, index) in getPointsProducts" v-bind:key="index" @click="visualizarTroca(item)" class="cursor-pointer" :class="item.points_value > getPoints ? 'text-color-0': 'text-color-1'">
                        <template v-slot:prepend>
                          <v-icon icon="mdi-eye" v-if="item.points_value > getPoints" ></v-icon>
                          <v-icon icon="mdi-star" color="var(--color-two)" v-else></v-icon>
                        </template>
                        <div class="w-100 text-left">
                          {{ item.name }}
                        </div>
                        <template v-slot:append>
                          {{ item.points_value }}
                        </template>
                      </v-list-item>
                    </v-list>
                    <div class="text-center mt-9" v-else>
                      <v-icon icon="mdi-star" color="var(--color-two)" size="60"></v-icon>
                      <br><br>
                      <b class="text-color-0">AGUARDE! PRÊMIOS EM BREVE.</b><br>
                      <span class="text-color-0">Não existem prêmios cadastrados.</span>
                    </div>
                  </v-skeleton-loader>
                  <DialogTroca :model="modelTroca" :fechar="fechar" :item="selectedTroca"></DialogTroca>
                </v-col>
                <v-col v-if="navPontos == 'transacao'" class="p-3" cols="12">
                  <v-skeleton-loader :loading="loadingHistory" type="image" width="100%" height="70px" class="with-margin justify-center">
                    <v-timeline side="end" :truncate-line="'start'" class="history-timeline mt-10" v-if="getPointsHistory.length > 0">
                      <v-timeline-item size="small" width="100%" v-for="(item, index) in getPointsHistory" v-bind:key="index" :dot-color="item.value > 0 ? 'var(--color-green)': 'var(--color-red)'" :icon="item.value > 0 ? 'mdi-plus': 'mdi-minus'" fill-dot icon-color="white">    
                        <template v-slot:opposite>
                          <v-row>
                            <v-col class="text-start">
                              <span v-if="item.type == 0">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} utilizado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 1">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} conquistado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 2">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} expirado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 3">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} cancelado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                            </v-col>
                          </v-row>
                        </template>
                        <v-row>
                          <v-col class="d-flex align-center justify-start">
                            <span v-if="item.value > 0">
                              <b class="text-specific text-nowrap">+{{ item.value }} pontos</b>
                            </span>
                            <span v-else>
                              <b class="text-danger text-nowrap">{{ item.value }} pontos</b>
                            </span>
                          </v-col>
                          <v-col class="d-flex align-center justify-start">
                            {{ $formatDate(item.date + " 00:00:00") }}
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </v-timeline>
                    <div class="text-center mt-9" v-else>
                      <Svgs :icon="'foguete'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
                      <br><br>
                      <b class="text-color-0">AGUARDE! LANÇAMENTOS EM BREVE.</b><br>
                      <span class="text-color-0">Não existem transações de pontos.</span>
                    </div>
                  </v-skeleton-loader>
                </v-col>
                <v-col v-if="navPontos == 'validade'" class="p-3" cols="12">
                  <v-skeleton-loader :loading="loadingHistory" type="image" width="100%" height="70px" class="with-margin justify-center">
                    <v-timeline side="end" :truncate-line="'start'" class="history-timeline mt-10" v-if="getPointsHistoryExpired.length > 0">
                      <v-timeline-item size="small" width="100%" v-for="(item, index) in getPointsHistoryExpired" v-bind:key="index" :dot-color="item.value > 0 ? 'var(--color-green)': 'var(--color-red)'" :icon="item.value > 0 ? 'mdi-plus': 'mdi-minus'" fill-dot icon-color="white">    
                        <template v-slot:opposite>
                          <v-row>
                            <v-col class="text-start">
                              <span v-if="item.type == 0">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} utilizado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 1">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} conquistado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 2">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} expirado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                              <span v-else-if="item.type == 3">
                                <b>Ponto{{item.value != 1 ? 's' : ''}} cancelado{{item.value != 1 ? 's' : ''}}</b> <i class="font-weight-light">(#{{ item.transaction_id }})</i><br>
                              </span>
                            </v-col>
                          </v-row>
                        </template>
                        <v-row>
                          <v-col class="d-flex align-center justify-start">
                            <span v-if="item.value > 0">
                              <b class="text-specific text-nowrap">+{{ item.value }} pontos</b>
                            </span>
                            <span v-else>
                              <b class="text-danger text-nowrap">{{ item.value }} pontos</b>
                            </span>
                          </v-col>
                          <v-col class="d-flex align-center justify-start">
                            {{ $formatDate(item.date_expire + " 00:00:00") }}
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </v-timeline>
                    <div class="text-center mt-9" v-else>
                      <Svgs :icon="'meteoro'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
                      <br><br>
                      <b class="text-color-0">PONTOS NÃO ENCONTRADOS.</b><br>
                      <span class="text-color-0">Não existem pontos a vencer.</span>
                    </div>
                  </v-skeleton-loader>
                </v-col>
                <v-col v-if="navPontos == 'ajuda'" cols="12">
                  <v-list class="mt-9 border py-0 text-color-0">
                    <v-list-item @click="visualizarAjuda(7);">
                      Como funciona?
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="visualizarAjuda(8);">
                      Dúvidas frequentes
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="visualizarAjuda(9);">
                      Entre em contato
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="visualizarAjuda(10);">
                      Política de Privacidade
                    </v-list-item>
                  </v-list>
                  <DialogAjuda :model="modelAjuda" :fechar="fechar" :ajuda="selectedAjuda"></DialogAjuda>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="link == 'carteira' && checkModules(8) == 8">
             <v-col class="v-col-12 text-center">
              <v-row>
                <v-col class="v-col-12 d-flex align-center justify-center text-color-0">
                  <div class="pontos pontos-border-vencer">
                    <span>
                      <span class="text-small">VOCÊ TEM</span><br>
                      <v-skeleton-loader :loading="loadingCarteira" type="text" class="justify-center">
                        <b class="text-xxlarge">{{ $formatNumber(getSaldoCarteira, {style: 'currency', currency: 'BRL'}) }}</b>
                      </v-skeleton-loader>
                    </span>
                  </div>
                </v-col>
                <v-col class="v-col-12">
                  <b class="text-color-0">Saldo para usar em suas compras</b>
                </v-col>
                <v-col class="p-3" cols="12">
                  <v-skeleton-loader :loading="loadingCarteira" type="image" width="100%" height="70px" class="with-margin justify-center">
                    <v-timeline side="end" :truncate-line="'start'" class="history-timeline mt-10" v-if="getCarteiraHistory.length > 0">
                      <v-timeline-item width="100%" v-for="(item, index) in getCarteiraHistory" v-bind:key="index" :dot-color="item.tipo == 0 ? 'var(--color-red)': (item.tipo == 1 ? 'var(--color-green)': 'var(--color-grey)')" :icon="item.tipo == 0 ? 'mdi-minus': (item.tipo == 1 ? 'mdi-plus': 'mdi-clock')" fill-dot icon-color="white">    
                        <v-row>
                          <v-col class="d-flex align-center justify-start">
                            <span v-if="item.tipo == 0">
                              <b class="text-color-red">{{ $formatNumber(item.valor, {style: 'currency', currency: 'BRL'}) }}</b>
                            </span>
                            <span v-else-if="item.tipo == 1">
                              <b class="text-color-green">+{{ $formatNumber(item.valor, {style: 'currency', currency: 'BRL'}) }}</b>
                            </span>
                            <span v-else>
                              <b class="text-color-0">-{{ $formatNumber(item.valor, {style: 'currency', currency: 'BRL'}) }}</b>
                            </span>
                          </v-col>
                          <v-col class="d-flex align-center justify-start">
                            <b class="text-color-0">{{ item.nome }}</b>
                          </v-col>
                          <v-col class="d-flex align-center justify-start text-color-0">
                            {{ $formatDate(item.data + " 00:00:00") }} às {{ $formatTime(item.data + " " + item.hora) }}
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </v-timeline>
                    <div class="text-center mt-9" v-else>
                      <Svgs :icon="'money'" :color="'fill-color-2'" :width="50" :height="50"></Svgs>
                      <br><br>
                      <b class="text-color-0">SEM TRANSAÇÕES NO MOMENTO.</b><br>
                      <span class="text-color-0">Compre produtos com indicador de cashback para ter parte do seu dinheiro de volta. O seu troco digital também poderá ser exibido aqui.</span>
                    </div>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Svgs from '@/components/Svgs.vue'
import DialogLembrete from '@/components/DialogLembrete.vue'
import DialogFolheto from '@/components/DialogFolheto.vue'
import DialogAjuda from '@/components/DialogAjuda.vue'
import DialogTroca from '@/components/DialogTroca.vue'
import DialogPremio from '@/components/DialogPremio.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: "Serviços",
  components: {
    Svgs,
    DialogLembrete,
    DialogFolheto,
    DialogAjuda,
    DialogTroca,
    DialogPremio
  },
  data() {
    return {
      link: '',
      titulo: '',
      modelLembrete: false,
      selectedLembrete: null,
      modelFolheto: false,
      selectedFolheto: null,
      modelAjuda: false,
      selectedAjuda: null,
      modelTroca: false,
      selectedTroca: null,
      modelPremio: false,
      navPontos: 'troca',
      pontos: {
        pontos_expirar: 100,
        pontos_acumulados: 200,
        itens_troca: [],
        itens_transacao: [],
        itens_expiracao: [],
      },
      paginacao: 0,
      isLoading: false,
      loadingItens: true,
      voucher: null
    }
  },
  watch: {
    navPontos(){
      this.paginacao = 0;
      this.loadingItens = true;
      this.loadData();
    }
  },
  computed: {
    ...mapGetters('main', {
      getConfig: 'getConfig',
      checkModules: 'checkModules'
    }),
    ...mapGetters('services', {
      getFolhetos: 'getFolhetos',
      getLembretes: 'getLembretes',
      getPremios: 'getPremios',
      getPoints: 'getPoints',
      getPointsProducts: 'getPointsProducts',
      getPointsHistory: 'getPointsHistory',
      getPointsExpired: 'getPointsExpired',
      getPointsHistoryExpired: 'getPointsHistoryExpired',
      checkView: 'checkView'
    }),
    ...mapGetters('carteira', {
      getSaldoCarteira: 'getSaldoCarteira',
      getCarteiraHistory: 'getCarteiraHistory'
    }),
    ...mapState('services', {
      loadingFolhetos: 'loadingFolhetos',
      loadingLembretes: 'loadingLembretes',
      loadingPremios: 'loadingPremios',
      loadingPoints: 'loadingPoints',
      loadingHistory: 'loadingHistory',
    }),
    ...mapState('carteira', {
      loadingCarteira: 'loadingCarteira'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    ...mapActions('services', {
      loadFolhetos: 'loadFolhetos',
      loadLembretes: 'loadLembretes',
      loadLembretesDetail: 'loadLembretesDetail',
      loadProducts: 'loadProducts',
      loadPremios: 'loadPremios',
      loadPremiosDetail: 'loadPremiosDetail',
      loadPoints: 'loadPoints',
      loadPointsHistory: 'loadPointsHistory',
      loadPointsExpired: 'loadPointsExpired',
      loadPointsHistoryExpired: 'loadPointsHistoryExpired',
      getPdf: 'getPdf',
      registerView: 'registerView',
      shake: 'shake'
    }),
    ...mapActions('carteira', {
      loadCarteira: 'loadCarteira'
    }),
    fechar: function(){
      this.modelLembrete = false;
      this.selectedLembrete = null;
      this.modelFolheto = false;
      this.selectedFolheto = null;
      this.modelAjuda = false;
      this.selectedAjuda = null;
      this.modelTroca = false;
      this.selectedTroca = null;
      this.modelPremio = false;
    },
    comparaData(data){
      data = data.split("-");
      data = new Date(data[0], data[1] - 1, data[2], 0, 0, 0);
      return data < new Date();
    },
    visualizarLembrete(lembrete){
      this.loadLembretesDetail(lembrete.id).then(function(){
        this.selectedLembrete = lembrete;
        this.modelLembrete = true;
        if(this.checkView('lembrete', lembrete.id)){
          this.registerView({ "type": 'lembrete', "id": lembrete.id });
        }
      }.bind(this));
    },
    visualizarFolheto(folheto){
      this.getPdf(folheto.hash).then(function(){
        this.selectedFolheto = folheto;
        this.modelFolheto = true;
        if(this.checkView('folheto', folheto.id)){
          this.registerView({ "type": 'folheto', "id": folheto.id });
        }
      }.bind(this));
    },
    visualizarAjuda(ajuda){
      this.selectedAjuda = ajuda;
      this.modelAjuda = true;
    },
    visualizarTroca(item){
      this.selectedTroca = item;
      this.modelTroca = true;
    },
    visualizarPremio(voucher){
      this.voucher = voucher;
      this.loadPremiosDetail(this.voucher.id).then(function(response){
        this.voucher.description = response.description;
        this.voucher.code = response.code;
        this.modelPremio = true;
      }.bind(this));
    },
    tryShake(){
      this.shake().then(function(response){
        if(response){
          if(response.winner == 1){
            this.voucher = response.voucher;
            this.modelPremio = true;
          } else {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: response.msg });
          }
        }
      }.bind(this));
    },
    Nav(){
      this.link = this.$route['params']['servico'];
      window.removeEventListener('scroll', this.loadData);
      switch(this.link){
        case "folhetos": 
          this.titulo = "Folhetos"; 
          this.loadFolhetos();
        break;
        case "lembretes": 
          this.titulo = "Lembretes"; 
          this.loadLembretes();
        break;
        case "premios": 
          this.titulo = "Prêmios e Brindes"; 
          this.loadPremios();
        break;
        case "pontos": 
          this.titulo = "Programa de Pontos";
          this.scroll();
          this.loadPoints();
          this.loadPointsExpired();
          this.loadProducts(this.paginacao).then(function(){
            this.isLoading = false;
            this.loadingProdutos = true;
            this.paginacao = 30;
          }.bind(this));
        break;
        case "carteira": 
          this.titulo = "Carteira Digital";
          this.loadCarteira(1);
        break;
      }
    },
    openLogin(){
      this.emitter.emit('dialogLogin');
    },
    scroll(){
      window.addEventListener('scroll', this.checkscroll);
    },
    loadData(){
      if(this.loadingItens && !this.isLoading){
        this.isLoading = true;
        switch(this.navPontos){
          case "troca": 
            this.loadProducts(this.paginacao).then(function(response){
              this.isLoading = false;
              if(!response){
                this.loadingItens = false;
              }
              this.paginacao += 30;
            }.bind(this));
          break;
          case "transacao": 
            this.loadPointsHistory(this.paginacao).then(function(response){
              this.isLoading = false;
              if(!response){
                this.loadingItens = false;
              }
              this.paginacao += 30;
            }.bind(this));
          break;
          case "validade": 
            this.loadPointsHistoryExpired(this.paginacao).then(function(response){
              this.isLoading = false;
              if(!response){
                this.loadingItens = false;
              }
              this.paginacao += 30;
            }.bind(this));
          break;
        }
      }
    },
    checkscroll: function() {
      let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) > (document.documentElement.offsetHeight - 2400);
      if (bottomOfWindow && document.documentElement.scrollTop > 0) {
        this.loadData();
      }
    }
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        if(this.getConfig.isu > 0){
          this.Nav();
        } else {
          this.openLogin();
        }
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name + " - " + this.titulo } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
  unmounted(){
    window.removeEventListener('scroll', this.checkscroll);
  }
}
</script>